const angular = require('angular')
const some = require('lodash/some')

module.exports = ['$utils', '$q', 'User', 'contactService', '$translate', '$httpParamSerializerJQLike', '$rootScope', '$state',
  function ($utils, $q, User, contactService, $translate, $httpParamSerializerJQLike, $rootScope, $state) {
    /* 封装邮件操作时常用底层ajax请求,
    此处service的基本原则：1.每个方法均返回promise（不接受callback）
    2.尽量只做http请求的逻辑，界面弹窗，回调等东西交由调用者的promise方法求做
    */

    // 用于搜索邮件的后续查询时，每取一条记录从mids拿到，用此方法拿到该邮件的详细信息，支持patten匹配搜索的关键字
    // 也用于写信前，根据邮件id获得邮件基本信息（主题，时间）等，来构造写信请求
    function getMessageInfos(options) {
      const deferred = $q.defer()
      if (!Object.prototype.hasOwnProperty.call(options, 'mboxa') || options.mboxa === undefined) {
        options.mboxa = User.getSelectedAccountSymbol()
      }
      if (!angular.isArray(options.ids)) {
        options.ids = [options.ids]
      }

      options.summaryWindowSize = typeof options.summaryWindowSize === 'number' ? options.summaryWindowSize : options.ids.length

      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:getMessageInfos',
          sid: User.getCurrentUser().sid
        },
        data: options
      }).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          deferred.resolve(data['var'] || [])
        } else if (code == 'S_PARTIAL_OK') { // 部分操作成功, 部分信件标识不存在
          deferred.reject(data)
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 彻底删除邮件，接受邮件id数组
    function deleteMessages(ids) {
      ids = ids || []
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:deleteMessages',
          sid: User.getCurrentUser().sid
        },
        data: {
          ids: ids
        }
      }).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          deferred.resolve(ids || [])
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 更新邮件状态，如标记、移动到
    // attrs请参考mbox_msginfo.txt mbox:updateMessageInfos的attrs定义
    function updateMessageInfos(ids, attrs, mboxa) {
      ids = ids || []
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:updateMessageInfos',
          sid: User.getCurrentUser().sid
        },
        data: {
          ids: ids,
          attrs: attrs,
          mboxa
        },
        cache: false
      }).then(function (data) {
        if (data.code == 'S_OK') {
          deferred.resolve(ids || [])
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 写信
    // action continue(需定时对composeId进行刷新，防止失效)  save（存草稿） deliver（发信）
    function compose(composeId, data, action) {
      const deferred = $q.defer()
      data = data || {}
      action = action || 'continue'
      if (composeId) {
        data.id = composeId
      }
      data.action = action
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:compose',
          sid: User.getCurrentUser().sid
        },
        data: data,
        cache: false
      }).then(function (data) {
        deferred.resolve(data)
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 获取 compose info object
    function getComposeInfo(options) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:getComposeInfo',
          sid: User.getCurrentUser().sid
        },
        data: options
      }).then(function (data) {
        if (data['code'] == 'S_OK') {
          deferred.resolve(data['var'])
        } else {
          deferred.reject(data)
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    /*  回复邮件/回复全部 */
    function replyMessage(id, toAll, subject, quoteHTMLStart, quoteHTMLEnd, mboxa) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:replyMessage',
          sid: User.getCurrentUser().sid
        },
        data: {
          id: id,
          toAll: toAll,
          mboxa: mboxa === '' ? '' : mboxa || User.getSelectedAccountSymbol(),
          attrs: {
            subject: subject,
            isHtml: true
          },
          quoteHTMLStart: quoteHTMLStart,
          quoteHTMLEnd: quoteHTMLEnd
        }
      }).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          deferred.resolve(data['var'] || {})
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    /*  转发，默认为HTML */
    function forwardMessage(id, subject, quoteHTMLStart, quoteHTMLEnd, mboxa) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:forwardMessages',
          sid: User.getCurrentUser().sid
        },
        data: {
          ids: [id],
          mode: 'quote',
          mboxa: mboxa === '' ? '' : mboxa || User.getSelectedAccountSymbol(),
          attrs: {
            subject: subject,
            isHtml: true,
            quick: true
          },
          quoteHTMLStart: quoteHTMLStart,
          quoteHTMLEnd: quoteHTMLEnd
        }
      }).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          deferred.resolve(data['var'] || {})
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 恢复编辑草稿
    function restoreDraft(id, mboxa) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:restoreDraft',
          sid: User.getCurrentUser().sid
        },
        data: {
          id: id,
          mboxa: mboxa === '' ? '' : mboxa || User.getSelectedAccountSymbol()
        }
      }).then(function (data) {
        deferred.resolve(data['var'] || {})
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    // 取消写信，释放所有服务器端资源
    function cancelComposes(id, deleteDraft) {
      deleteDraft = deleteDraft || false
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:cancelComposes'
        },
        data: {
          ids: [id],
          deleteDraft: deleteDraft
        }
      }).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          deferred.resolve(data['var'] || {})
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    /**
     * 获取单封邮件
     * @param params
     */
    function readMessage(options) {
      const deferred = $q.defer()
      const mboxa = options.mboxa || ''
      const mboxId = mboxa ? parseInt(mboxa.split('@')[1]) : undefined
      const accessNum = mboxa === '' ? -1 : (mboxId ? User.getAccountAccessById(mboxId) : User.getSelectedAccountAccess())
      const hasAccess = accessNum === -1 || accessNum === 1
      options = angular.extend({
        mode: 'html',
        filterHeads: true,
        filterStylesheets: false,
        filterLinks: false,
        filterImages: false,
        autoName: true,
        markRead: hasAccess,
        returnAntispamInfo: true,
        stripContentTrs: false, // 超大附件显示形式，true会返回trsAttachments，false会内嵌在正文中显示
        returnHeaders: {
          Sender: 'A'
        },
        supportTNEF: true
      }, options)
      if (!Object.prototype.hasOwnProperty.call(options, 'mboxa') || options.mboxa === undefined) {
        options.mboxa = User.getSelectedAccountSymbol()
      }
      const query = {
        func: 'mbox:readMessage',
        sid: User.getCurrentUser().sid,
      }
      const proxyHost = $rootScope.settings.proxyHost || ''
      if (proxyHost.startsWith('http')) {
        const proxyWebname = `${proxyHost}/coremail/s/?func=mbox:getMessageData`
        console.log(proxyWebname)
        options.dataGetPrefix = proxyWebname
      }
      User.getCurrentUser().simpleCall({
        query,
        data: options
      }).then(function (data) {
        if (data.code === 'S_OK') {
          deferred.resolve(data['var'])
        } else {
          deferred.reject(data)
        }
      }, function (data) {
        deferred.reject(data)
      })

      return deferred.promise
    }

    // 获取附件下载地址
    function getDownloadURL(mid, part) {
      const queryData = {
        func: 'mbox:getMessageData',
        sid: User.getCurrentUser().sid,
        mid: mid,
        part: part,
        mode: 'download'
      }
      const downloadURL = User.getCurrentUser().wmsvrClient.getRequestURL({
        query: queryData
      })
      return downloadURL
    }
    // 搜索往来邮件
    function searchMailDealings(data) {
      const deferred = $q.defer()
      const user = User.getCurrentUser()
      const options = {
        fid: 0,
        order: data.order,
        desc: true,
        windowSize: 20,
        total: '',
        filter: {
          flags: { draft: false, rcptFailed: false },
          chatWithAddress: `gxchen@coremail.cn,${user.config.email}`
        },
        conditions: [],
        groupings: {
          'flags.attached': '',
          'flags.read': '',
          'flags.flagged': '',
          fromAddress: { top: -1 },
          fid: { top: -1 },
          receivedDate: { keys: { '1w': null, '1m': null, '2m': null } },
          priority: ''
        }
      }
      user.simpleCall({
        query: {
          func: 'mbox:searchMessages',
          sid: user.sid
        },
        data: options
      }).then(function (data) {
        const total = data.var.length
        data.total = total
        deferred.resolve(data)
      }, function (data) {
        const total = data.var.length
        data.total = total
        deferred.reject(data)
      })
      return deferred.promise
    }
    // 获取邮件完整信息
    function getAllMailMessage(id, mboxa) {
      const deferred = $q.defer()
      User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:editMessage',
          sid: User.getCurrentUser().sid
        },
        data: {
          id: id,
          mboxa: mboxa === '' ? '' : mboxa || User.getSelectedAccountSymbol()
        }
      }).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          deferred.resolve(data['var'] || [])
        } else if (code == 'FA_ID_NOT_FOUND') { // 新建不存在
          deferred.reject(data)
        }
      }, function (error) {
        deferred.reject(error)
      })
      return deferred.promise
    }

    /**
   * 附件风险提示 #CIM-26868
   * @param {{filename,from}[]} attachments 需要检查的附件列表
   * @param {string} action 操作说明翻译文字
   * @return {EPromise} 不需要显示风险提示或用户确认风险提示后 resolve
   */
    function checkAttachmentRisk(attachments, action = '') {
      if (!$rootScope.settings.enableAttachSecurityAlert) return $q.resolve(true)

      const isRiskyAttachment = some(attachments, item => {
        const fromStranger = item.from && contactService.isStranger(item.from)
        const extName = $utils.$attachment.getExtName(item.filename)
        const isRiskySuffix = !!~$rootScope.settings.unsecuredAttachTypeList.indexOf(extName)
        return fromStranger || isRiskySuffix
      })
      return isRiskyAttachment ? $utils.$pop.confirmPopup('', $translate.instant(`READ.TIP_UNTRUSTED_FILE`, {action}), {
        highlightCancel: true
      }) : $q.resolve(true)
    }

    return {
      getMessageInfos: getMessageInfos,
      deleteMessages: deleteMessages,
      updateMessageInfos: updateMessageInfos,
      replyMessage: replyMessage,
      forwardMessage: forwardMessage,
      restoreDraft: restoreDraft,
      compose: compose,
      cancelComposes: cancelComposes,
      readMessage: readMessage,
      getDownloadURL: getDownloadURL,
      getComposeInfo: getComposeInfo,
      searchMailDealings: searchMailDealings,
      getAllMailMessage: getAllMailMessage,
      checkAttachmentRisk
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/mailService.js